const Data =[
    {
        name : "Palm Harbor",
        price : 1500,
        address : "2699 Green Vally,Highland Lakh,FL",
        pic : "https://images.unsplash.com/photo-1570129477492-45c003edd2be?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 3,
        location : "USA",
        date : 1,
        type : "House",
        bathroom : 2,
        area : 35
    },
    {
        name : "Beverly Springfeild",
        price : 1200,
        address : "2821 Lake Sevilla,Palm Harbour,TX",
        pic : "https://images.unsplash.com/photo-1568605114967-8130f3a36994?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 4,
        location : "USA",
        date : 2,
        type : "Plot",
        bathroom : 2,
        area : 50
    },
    {
        name : "Mukesh Ambani",
        price : 2095,
        address : "2699 New Mumbai,IN",
        pic : "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 5,
        location : "india",
        date : 2,
        type : "multifb",
        bathroom : 4,
        area : 100
    },
    {
        name : "Faulkner Ave",
        price : 950,
        address : "2699 Silicon Vally,Highland Lake,SF",
        pic : "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 3,
        location : "india",
        date : 1,
        type : "House",
        bathroom : 2,
        area : 40
    },
    {
        name : "Willium Lorey",
        price : 1800,
        address : "2699 Green Vally,Highland Lakh,FL",
        pic : "https://images.unsplash.com/photo-1576941089067-2de3c901e126?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 4,
        location : "USA",
        type : "Plot",
        date : 3,
        bathroom : 2,
        area : 45
    },
    {
        name : "Adani House",
        price : 2900,
        address : "2699 Ram Bagh,Near Circle,IN",
        pic : "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 6,
        location : "india",
        type : "multifb",
        date : 4,
        bathroom : 5,
        area : 150
    },
    {
        name : "Adams Warren",
        price : 2095,
        address : "2699 Red Vally,Rockland,SL",
        pic : "https://images.unsplash.com/photo-1582063289852-62e3ba2747f8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 4,
        location : "USA",
        type : "multifb",
        date : 4,
        bathroom : 4,
        area : 65
    },
    {
        name : "JAMES LOURIS",
        price : 2950,
        address : "699 Exuma, Marblehead, USA",
        pic : "https://images.unsplash.com/photo-1430285561322-7808604715df?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 4,
        location : "USA",
        type : "Flat",
        date : 4,
        bathroom : 5,
        area : 400
    },
    {
        name : "JACOB HAULTINGS",
        price :3450,
        address : "269 South Salt Lake, US",
        pic : "https://images.unsplash.com/photo-1599427303058-f04cbcf4756f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 6,
        location : "USA",
        type : "multifb",
        date : 2,
        bathroom : 3,
        area : 350
    },
    {
        name : "Laurance Willium",
        price : 2000,
        address : "200 Texas, US ",
        pic : "https://images.unsplash.com/photo-1608045742930-48cee6018255?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 3,
        location : "USA",
        type : "Flat",
        date : 3,
        bathroom : 3,
        area : 305
    },
    {
        name : "H.R WILLIAMS",
        price : 2005,
        address :"789 Barra Da Tijuca, BRAZIL",
        pic : "https://images.unsplash.com/photo-1557434440-27ba0f1654e8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 6,
        location : "USA",
        type : "Plot",
        date : 1,
        bathroom : 2,
        area : 435
    },
    {
        name : "SUNDAR PICHAI",
        price : 4000,
        address : "555 Krishnarajasagar,Mysore Karnataka,INDIA",
        pic : "https://images.unsplash.com/photo-1617375069407-77ada5579d6f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 6,
        location : "india",
        type : "multifb",
        date : 2,
        bathroom : 4,
        area : 800
    },
    {
        name : "ABDULREHMAN QAZI",
        price : 2050,
        address : "270 LEH,Jammu&Kashmir, INDIA",
        pic : "https://images.unsplash.com/photo-1587094313669-faf7668ed8a8?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 5,
        location : "india",
        type : "House",
        date : 4,
        bathroom : 3,
        area : 530
    },
    {
        name : "CHINAMMA IYER",
        price : 3600,
        address : "432 Coorg, INDIA",
        pic : "https://images.unsplash.com/photo-1588012886079-baef0ac45fbd?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 3,
        location : "india",
        type : "Plot",
        date : 4,
        bathroom : 2,
        area : 335
    },
    {
        name : "AMAN CHOPDRA",
        price : 2509,
        address : "509 Guwahati,Assam, INDIA",
        pic : "https://images.unsplash.com/photo-1602895931791-d78ac88edc7b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8?auto=format&fit=crop&w=1170&q=80",
        beds : 7,
        location : "india",
        type : "multifb",
        date : 4,
        bathroom : 3,
        area : 620
    },
]
export default Data;